import { createTypedEnum } from '@reckon-web/formschema-enums';

export const JobCommentTypeEnum = createTypedEnum({
  Comment: 'Comment',
  SignOffRequested: 'SignOff_Requested',
  SignOffApproved: 'SignOff_Approved',
  SignOffDeclined: 'SignOff_Declined',
  SignOffWithdrawn: 'SignOff_Withdrawn',
  SignOffRevoked: 'SignOff_Revoked',
} as const);
export type JobCommentTypeEnumValue =
  (typeof JobCommentTypeEnum.values)[number];
export type JobCommentTypeEnumLabel =
  (typeof JobCommentTypeEnum.labels)[number];
